import * as React from 'react';
import { TableCell, TableCellProps, Grid, IconButton, Skeleton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

interface Props {
  action?: 'edit' | 'expand';
  loading: boolean;
  editing: boolean;
  onEditClick: () => void;
  onDeleteClick: () => void;
  align?: TableCellProps['align'];
  showDelete: boolean;
}

const ActionCell: React.FC<Props> = ({
  loading,
  editing,
  onEditClick,
  onDeleteClick,
  align = 'right',
  showDelete = true,
  action = 'edit'
}: Props) => {
  const { t } = useTranslation('common');
  const actionIconToUse = action === 'edit'
    ? <EditIcon />
    : <ExpandMore />;
  return (
    <TableCell align={align}>
      <Grid
        container
        direction="row"
        spacing={2}
        justifyContent="flex-end"
        wrap="nowrap"
      >
        <Grid item>
          {loading ? (
            <Skeleton>
              <IconButton>
                {actionIconToUse}
              </IconButton>
            </Skeleton>
          ) : (
            <IconButton
              title={t(`${editing ? 'cancel' : 'edit'}`)}
              color="secondary"
              onClick={onEditClick}
            >
              {editing ? <CloseIcon /> : actionIconToUse}
            </IconButton>
          )}
        </Grid>
        {showDelete && (
          <Grid item>
            {loading ? (
              <Skeleton>
                <IconButton>
                  <DeleteIcon />
                </IconButton>
              </Skeleton>
            ) : (
              <IconButton
                title={t('delete')}
                color="secondary"
                onClick={onDeleteClick}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Grid>
        )}
      </Grid>
    </TableCell>
  );
};

export default ActionCell;
